import { Controller } from '@hotwired/stimulus'
import scrollIntoView from 'scroll-into-view'

export default class extends Controller {
  connect() {
    window.scrollFlowIntoView = this.scrollFlowIntoView
    this.scrollFlowIntoView()
  }

  scrollFlowIntoView = () => {
    scrollIntoView(this.element, {
      time: 300,
      align: { top: 0 },
    })
  }

  disconnect() {}
}
